// 레퍼런스(flexg)의 상단 영역이 50~56px 이라 거기 맞춘다.
// 56px 은 임의 값이 아니라 TopNav 안에서 가장 큰 요소인 뒤로가기 버튼(size=large, 40px)에
// TopNavWrapper 의 세로 패딩 8px 을 위아래로 더한 값이다. 이보다 줄이면 버튼이 넘친다.
// (2026-09-17 KST 수정: 77px -> 56px)
export const topBarHeight = "56px";
export const topBarHeightSubtitle = "96px";
export const topBarHeightSubtitleTop = "72px";
// 상단 가로 메뉴바. flexg 의 .headpartialwrap 실측값. (2026-09-17 KST 추가)
// 상세 팝업 창에서는 메뉴바를 숨기므로 AppLayout 이 변수를 0 으로 바꾼다. 상세 레이아웃
// 높이 계산이 이 값을 빼므로 변수로 두어야 빈 공간이 안 남는다. (2026-10-02 KST 수정)
export const topMenuBarHeight = "var(--app-top-menu-bar-height, 50px)";
export const appLoaderHeight = 2;
export const savebarHeight = "64px";
export const borderHeight = "1px";

// 목록에서 상세를 여는 작은 브라우저 창 (2026-10-02 KST 추가). 창 이름은 그 창 안에서
// 페이지를 옮겨도 유지되므로, 이 이름이면 왼쪽 메뉴·상단 메뉴바 없이 내용만 그린다.
export const detailPopupWindowName = "dashboard-detail-popup";
// 주문 상세 팝업에서 상품 상세를 열 때 쓰는 두 번째 팝업 (2026-10-06 KST 추가).
// 같은 이름을 쓰면 주문 팝업이 상품 페이지로 바뀌어 버려 이름을 따로 둔다.
export const productDetailPopupWindowName = `${detailPopupWindowName}-product`;
export const isDetailPopupWindow = (): boolean => window.name.startsWith(detailPopupWindowName);
